import React from 'react';
import AnimationControlsContainer from '../../AnimationControlsContainer';
import KaraokeAnimationEmphasisOptions from './KaraokeAnimationEmphasisOptions';
import KaraokeAnimationWordEmphasisColorSelector from './KaraokeAnimationWordEmphasisColorSelector';
import KaraokeAnimationWordFutureColorSelector from './KaraokeAnimationWordFutureColorSelector';
import KaraokeAnimationWordPastColorSelector from './KaraokeAnimationWordPastColorSelector';

export interface KaraokeAnimationControlsProps {}

const KaraokeAnimationControls: React.FC<KaraokeAnimationControlsProps> = () => {
  return (
    <AnimationControlsContainer>
      <KaraokeAnimationEmphasisOptions />

      <KaraokeAnimationWordPastColorSelector />

      <KaraokeAnimationWordEmphasisColorSelector />

      <KaraokeAnimationWordFutureColorSelector />
    </AnimationControlsContainer>
  );
};

export default KaraokeAnimationControls;
